(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.plt-tabs').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('.plt-tabs__btn');
      var panels = tabs.querySelectorAll('.plt-tabs__panel');

      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) {
            b.classList.remove('plt-tabs__btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('plt-tabs__panel--active');
          });
          btn.classList.add('plt-tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');
          panels[i].classList.add('plt-tabs__panel--active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
